import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule, NgbTooltipConfig, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { SvgIconComponent } from '../svg-icon/svg-icon.component';

import { IContentRatingConfig } from '../../interfaces/shared.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EContentRatingType } from '../../enums/shared.enums';
import { ETermsOfService } from 'app/enums/terms-of-service.enums';

@Component({
  selector: 'stxt-content-rating',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, SvgIconComponent],
  templateUrl: './content-rating.component.html',
  styleUrl: './content-rating.component.scss',
  providers: [NgbTooltipConfig]
})
export class ContentRatingComponent {
  @Input() ratingType: EContentRatingType;
  @Input() subscribed: boolean;

  chatIcon: ISvgConfig = { name: 'chat_tooltip', fill: ESvgTypes.None };
  capitalLetterIcon: ISvgConfig = { name: 'capital-letter', fill: ESvgTypes.None };
  eyeIcon: ISvgConfig = { name: 'eye-alt', fill: ESvgTypes.None };
  eyeSlashIcon: ISvgConfig = { name: 'eye-slash', fill: ESvgTypes.None };
  underWearIcon: ISvgConfig = { name: 'tank-top', fill: ESvgTypes.None };
  EContentRatingType = EContentRatingType;
  ETermsOfService = ETermsOfService;

  private hideTimer: NodeJS.Timeout;
  private currentTooltip: NgbTooltip;

  private readonly ratingConfigs: IContentRatingConfig[] = [
    {
      type: EContentRatingType.SFW,
      label: '😇 SFW',
      title: '😇 Safe For Work (SFW)',
      description:
        'Light R-rated content: no explicit depictions, actions, suggestions, or references',
      chatStyle: ['Playful chats', 'Flirty, mildly suggestive language'],
      imageTypes: ['Non-explicit partial nudity', 'Visible skin or skintight clothing']
    },
    {
      type: EContentRatingType.NSFW,
      label: '🔥 NSFW',
      title: '🔥 Not Safe For Work (NSFW)',
      description:
        'X-rated content: Non-explicit depictions of sexual behavior, but no sexual activities shown',
      chatStyle: ['Sexually suggestive chats', 'Sexually charged language'],
      imageTypes: ['Non-explicit full nudity', 'Highly revealing to no clothing']
    }
  ];

  getCurrentRatingConfig(): IContentRatingConfig {
    return (
      this.ratingConfigs.find(config => config.type === this.ratingType) || this.ratingConfigs[0]
    );
  }

  getSafeForWorkText(): string {
    const config = this.getCurrentRatingConfig();
    return `${config.label}`;
  }

  getRatingTooltipTitle(): string {
    return this.getCurrentRatingConfig().title;
  }

  getRatingTooltipDescription(): string {
    return this.getCurrentRatingConfig().description;
  }

  getRatingChatStyles(): string[] {
    return this.getCurrentRatingConfig().chatStyle;
  }

  getRatingImageTypes(): string[] {
    return this.getCurrentRatingConfig().imageTypes;
  }

  showTooltip(tooltip: NgbTooltip): void {
    this.cancelHideTimer();

    if (this.currentTooltip && this.currentTooltip !== tooltip) {
      this.currentTooltip.close();
    }

    this.currentTooltip = tooltip;
    tooltip.open();
  }

  startHideTimer(tooltip: NgbTooltip): void {
    this.hideTimer = setTimeout(() => {
      tooltip.close();
      this.currentTooltip = null;
    }, 50); // Small delay to allow mouse movement to tooltip
  }

  cancelHideTimer(): void {
    if (!this.hideTimer) return;
    clearTimeout(this.hideTimer);
    this.hideTimer = null;
  }

  hideTooltip(): void {
    if (this.currentTooltip) {
      this.currentTooltip.close();
      this.currentTooltip = null;
    }
  }
}
